import { render, staticRenderFns } from "./TotalDataGraph.vue?vue&type=template&id=2f114bc8&scoped=true&"
import script from "./TotalDataGraph.vue?vue&type=script&lang=js&"
export * from "./TotalDataGraph.vue?vue&type=script&lang=js&"
import style0 from "./TotalDataGraph.vue?vue&type=style&index=0&id=2f114bc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f114bc8",
  null
  
)

export default component.exports